<ion-header>
    <ion-toolbar #headerToolbar style="--background:var(--myDisabledEnabledColor)">
        <ion-buttons slot="start">
            <ion-back-button [disabled]=vb.disabled data-test="backButton"></ion-back-button>
        </ion-buttons>
        <ion-title data-test="title" #title (click)="onTitleClick()">Ticket</ion-title>
        <!-- <ion-buttons slot="end">
            <ion-button color="light" id="more" (click)="onMoreClick($event)" data-test="moreButton">
                <ion-icon name="ellipsis-horizontal"></ion-icon>
            </ion-button>
        </ion-buttons> -->
    </ion-toolbar>
</ion-header>

<ion-content>
    <ion-list-header color="secondary">
        Passenger Information - (Step 1 of 3)
    </ion-list-header>

    <ion-list lines="none">
        <form name="form" (ngSubmit)="f.form.valid && onNextClick(f)" #f="ngForm" novalidate>
            <ion-item>
                <ion-label class="ion-text-wrap" position="stacked">Primary Passenger's Name</ion-label>
                <ion-input id="passengerName" type="text" [(ngModel)]="vm.ticket.passengerName" name="passengerName"
                    #passengerName="ngModel" required [(ngModel)]="vm.ticket.passengerName"
                    [ngClass]="{ 'is-invalid': f.submitted && passengerName.invalid }" data-test="passengerName">
                </ion-input>
                @if (submitted && passengerName.invalid) {
                <div>
                    <div class="validationErrorMsg">Passenger Name is required.</div>
                </div>
                }
            </ion-item>

            <ion-item class="lblAdvanced">
                <ion-label class="ion-text-wrap" data-test="numPassengersLabel">
                    Number of Passengers: {{vm.ticket.numPassengers}}
                </ion-label>
            </ion-item>

            <ion-item>
                <ion-range color="primary" class="insetRange" min="1" max="10" snaps="true" value="5"
                    [(ngModel)]="vm.ticket.numPassengers" name="numPassengers" data-test="numPassengers">
                    <ion-label class="ion-text-wrap" color="primary" slot="start">1</ion-label>
                    <ion-label class="ion-text-wrap" color="primary" slot="end">10</ion-label>
                </ion-range>
            </ion-item>

            <ion-item>
                <ion-label class="ion-text-wrap" position="stacked">Cell Phone</ion-label>
                <ion-input id="cellPhone" type="tel" appPhoneMask placeholder="(xxx) xxx-xxxx"
                    [(ngModel)]="vm.ticket.cellPhone" #cellPhone="ngModel" required name="cellPhone" minlength="14"
                    maxlength="14" data-test="cellPhone">
                </ion-input>
                @if (submitted && cellPhone.invalid) {
                <div>
                    <div class="validationErrorMsg">A 10 digit Cell Phone number is required.</div>
                </div>
                }
            </ion-item>

            <ion-item>
                <ion-label class="ion-text-wrap" position="stacked">Driver Notes</ion-label>
                <ion-input id="notes" type="text" [(ngModel)]="vm.ticket.note" name="notes"
                    placeholder="Gate Code, Call When Arrived, etc" data-test="notes"></ion-input>
            </ion-item>

            <ion-item>
                <ion-label class="ion-text-wrap">
                    Priority: {{vm.isUrgencyStr}}
                </ion-label>
                <ion-toggle id="priorityToggle" [(ngModel)]="vm.ticket.isUrgent" name="isUrgent"
                    (ionChange)="onToggleUrgencyClick()" data-test="isUrgent">
                </ion-toggle><br />
            </ion-item>

            <!-- @if (isDebugMode) {
  <div>
                <ion-item>
                    <ion-label class="ion-text-wrap" position="stacked">Num Passengers - For Protractor Testing!
                    </ion-label>
                    <ion-input id="numPassengersText" type="number" [min]="1" [max]="20" name="x"
                        [(ngModel)]="vm.ticket.numPassengers"></ion-input>
                </ion-item>
            </div>
} -->
        </form>
    </ion-list>

    <ion-fab vertical="bottom" horizontal="end">
        <ion-fab-button [disabled]=vb.disabled (click)="onNextClick(f)" title="Next" data-test="ticketNext1">
            <ion-icon name="chevron-forward"></ion-icon>
        </ion-fab-button>
    </ion-fab>
</ion-content>